import fetch from '@/plugin/axios'

export function page (query) {
  return fetch({
    url: '/api/ocr/elementType/list',
    method: 'get',
    params: query
  })
}

export function addObj (obj) {
  return fetch({
    url: '/api/ocr/elementType/element',
    method: 'post',
    data: obj
  })
}

export function getObj (id) {
  return fetch({
    url: '/api/ocr/elementType/elementReg/' + id,
    method: 'get'
  })
}

export function delObj (id) {
  return fetch({
    url: '/api/ocr/elementType/' + id,
    method: 'delete'
  })
}

export function putObj (obj) {
  return fetch({
    url: '/api/ocr/elementType/relevancyReg',
    method: 'post',
    data: obj
  })
}
